import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Icon from '@bit/atd.web.icons'
import Button from '@bit/atd.web.button'
import colors from '@bit/atd.web.colors'

const useStyles = makeStyles({
  button: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  buttonIcon: {
    position: 'absolute',
    left: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '16px !important',
    height: '16px',
  },
  buttonText: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '18px',
    paddingLeft: '24px',
  },
})

type PropsType = {
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const EditAction = ({ onClick, disabled }: PropsType): ReactElement => {
  const classes = useStyles()
  return (
    <Button
      disabled={disabled}
      variant="tertiary"
      // @ts-ignore
      onClick={onClick}
      className={classes.button}
    >
      <Icon
        className={classes.buttonIcon}
        glyph="edit"
        size={16}
        color={colors.ctaPrimary}
      />
      <span className={classes.buttonText}>Edit Section</span>
    </Button>
  )
}

export default EditAction
